import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Wrench, Info, MessageCircle, Phone } from 'lucide-react';
import { BRAND, FEATURES } from '../lib/brand';

export default function PannenhilfePage() {
  // Feature flag: when disabled, show informational notice. Backend route still exists
  // for later reactivation when a towing/breakdown partner is onboarded.
  if (!FEATURES.pannenhilfe_enabled) {
    const whatsappHref = `https://wa.me/${BRAND.whatsapp.replace('+', '')}?text=${encodeURIComponent('Hallo, ich habe eine Panne / mein Fahrzeug ist nicht fahrbereit. Können Sie mich bei den nächsten Schritten unterstützen?')}`;
    return (
      <div className="min-h-screen bg-slate-50">
        <Header />
        <main className="max-w-2xl mx-auto px-4 sm:px-6 py-10" data-testid="pannenhilfe-disabled">
          <Card className="rounded-2xl border-amber-200 bg-amber-50/60">
            <CardContent className="p-6">
              <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-xl bg-amber-200 text-amber-900 flex items-center justify-center"><Info className="h-5 w-5" /></div>
                <div>
                  <h1 className="font-heading font-semibold text-xl text-[hsl(var(--primary))]">Pannenhilfe aktuell nicht aktiviert</h1>
                  <p className="text-sm text-slate-700 mt-2">
                    Wir arbeiten derzeit am Aufbau verlässlicher Abschlepp- und Werkstattpartner. Sobald ein Partner vor Ort verfügbar ist, wird die Pannenhilfe hier wieder freigeschaltet.
                  </p>
                  <p className="text-sm text-slate-700 mt-2">
                    Bei akuter Panne kontaktieren Sie uns bitte direkt — wir helfen Ihnen bei der Koordination der nächsten Schritte.
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    <a href={`tel:${BRAND.phone}`} className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-[hsl(var(--primary))] text-white text-sm font-medium hover:bg-[hsl(210_73%_12%)]" data-testid="pannenhilfe-call">
                      <Phone className="h-4 w-4" /> {BRAND.phoneDisplay}
                    </a>
                    <a href={whatsappHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-[#25D366] text-white text-sm font-medium hover:opacity-95" data-testid="pannenhilfe-whatsapp">
                      <MessageCircle className="h-4 w-4" /> WhatsApp Kontakt
                    </a>
                    <Link to="/unfall-melden" className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-white border border-slate-200 text-slate-900 text-sm font-medium hover:bg-slate-50" data-testid="pannenhilfe-report">
                      Schaden melden
                    </Link>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
          <p className="mt-4 text-[11px] text-slate-500">
            Hinweis: Bei lebensbedrohlicher Gefahr wählen Sie 112 (Euronotruf), 144 (Rettung) oder 133 (Polizei).
          </p>
        </main>
      </div>
    );
  }

  // Original Pannenhilfe form kept here for when the feature flag is re-enabled.
  // (Trimmed to keep file size manageable; original full form intentionally retained
  // in version control history for re-activation.)
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-10 w-10 rounded-xl bg-[hsl(var(--accent))] text-white flex items-center justify-center"><Wrench className="h-5 w-5" /></div>
          <div>
            <h1 className="font-heading font-semibold text-2xl text-[hsl(var(--primary))]">Pannenhilfe</h1>
            <p className="text-sm text-slate-600">Bitte aktivieren Sie FEATURES.pannenhilfe_enabled in /app/frontend/src/lib/brand.js.</p>
          </div>
        </div>
        <Card className="rounded-2xl border-slate-200">
          <CardContent className="p-5">
            <p className="text-sm text-slate-700">Die vollständige Pannenhilfe-Funktionalität wird aktiviert, sobald der Feature-Flag gesetzt ist.</p>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
